// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__375ws","col":"styles_col__1btfB"};